import { TextField } from '@mui/material';

const InputUI = (props) => {
  return (
    <TextField
      sx={{ width: '100%' }}
      autoComplete="off"
      onWheel={(e) => {
        e.target.blur();
      }}
      InputLabelProps={{
        style: { color: '#607d8b' },
      }}
      inputProps={{ step: props.precision, readOnly: props.readOnly ?? false, ...props.inputProps }}
      {...props}
    />
  );
};

export default InputUI;
